import styled from 'styled-components';
import { boxModelStyles } from '../../../styles/css';

interface IStyledSportIconProps {
  src: string;
  name: string;
}

const StyledSportIcon = styled.img.attrs<IStyledSportIconProps>(({ name }) => ({
  alt: `${name} icon`,
  className: `sport-icon ${name.replace(' ', '-').toLowerCase()}`
}))`
  ${boxModelStyles}
`;

export default StyledSportIcon;
